export default __webpack_public_path__ + "static/media/img-slider-finedae-1.e9a31126.png";